import ApiService from '@/services/core/api.service'

const ReportService = {
  async getFarmerCallLogs (query) {
    return ApiService.get(`agent/farmer-reports/call-logs?${query}`)
  },

  async getFarmerConnectedSummaries (query) {
    return ApiService.get(`agent/farmer-reports/connected-summaries?${query}`)
  },

  async getFarmerUnsuccessfulSummaries (query) {
    return ApiService.get(`agent/farmer-reports/unsuccessful-summaries?${query}`)
  },

  async getFarmerPromotionSummaries (query) {
    return ApiService.get(`agent/farmer-reports/promotion-summaries?${query}`)
  },

  async getVisitRequestHistories (query) {
    return ApiService.get(`agent/farmer-reports/visit-request-histories?${query}`)
  },

  async getCallRequestHistories (query) {
    return ApiService.get(`agent/farmer-reports/call-request-histories?${query}`)
  },

  async getDealerCallLogs (query) {
    return ApiService.get(`agent/dealer-reports/call-logs?${query}`)
  },

  async getDealerConnectedSummaries (query) {
    return ApiService.get(`agent/dealer-reports/connected-summaries?${query}`)
  },

  async getDealerUnsuccessfulSummaries (query) {
    return ApiService.get(`agent/dealer-reports/unsuccessful-summaries?${query}`)
  },

  async getSMSSummaries (query) {
    return ApiService.get(`agent/farmer-reports/sms-summaries?${query}`)
  },

  async getSatisfactionSurvey (query) {
    return ApiService.get(`agent/farmer-reports/satisfaction-surveys?${query}`)
  }
}

export default ReportService
